<template>
  <section class="grey_bg" aria-labelledby="conflict-heading">
    <div class="container mt-4">
      <h1 id="conflict-heading" class="mt-4 page-title">Guidelines for dealing with Conflicts of Interest of Research Analyst in Securities Market</h1>

      <p class="mt-4">These guidelines are in addition to the provisions contained in Securities And Exchange Board Of India (Research Analysts) Regulations, 2014 (RA regulations) and other circulars issued by the Board from time to time regarding dealing with conflict of interest, in respect of intermediaries.</p>
      
      <p>Research Analyst is governed by the provisions for avoidance of conflict of interest as mandated in the RA regulations read with relevant circulars issued from time to time by SEBI. On the lines of Principle 8 of the International Organisation of Securities Commissions (IOSCO) Objectives and Principles of Securities Regulations, these additional guidelines are put in place for elimination of their conflict of interest.</p>

      <p>Research Analyst shall adhere to these guidelines for avoiding or dealing with or managing conflict of interest. Research Analyst shall be responsible for educating their associated persons for compliance of these guidelines.</p>

      <p>Research Analyst has laid down policies and internal procedures to identify and avoid or to deal or manage actual or potential conflict of interest. Research Analyst has developed an internal code of conduct governing operations and formulated standards of appropriate conduct in the performance of its activities. These policies shall be communicated to all concerned</p>

      <p>Research Analyst at all times shall maintain high standards of integrity in the conduct of its business Research Analyst shall ensure fair treatment of their clients and not discriminate amongst them</p>

      <p>Research Analyst shall ensure that its personal interest does not, at any time conflict with their duty to their clients and client’s interest always takes primacy in their advice, investment decisions and transactions.</p>

      <p>Research Analyst shall make appropriate disclosure to the clients of possible source or potential areas of conflict of interest which would impair their ability to render fair, objective and unbiased services.</p>

      <p>Research Analyst shall endeavor to reduce opportunities for conflict through prescriptive measures such as through information barriers to block or hinder the flow of information from one department/ unit to another, etc.;</p>

      <p>Research Analyst shall place appropriate restrictions on transactions in securities while handling a mandate of issuer or client in respect of such security so as to avoid any conflict.</p>

      <p>Research Analyst shall not deal in securities while in possession of material non published information.</p>

      <p>Research Analyst shall not to communicate the material non published information while dealing in securities on behalf of others.</p>

      <p>Research Analyst shall not in any way contribute to manipulate the demand for or supply of securities in the market or to influence prices of securities.</p>

      <p>Research Analyst shall not have an incentive structure that encourages sale of products not suiting the risk profile of their clients.</p>

      <p>Research Analyst shall not share information received from clients or pertaining to them, obtained as a result of their dealings, for their personal interest.</p>

      <p>Research Analyst shall put in place systems for implementation of the aforementioned guidelines and provide necessary guidance enabling identification, elimination or management of conflict of interest situations. The Research Analyst shall review the compliance of the above guidelines periodically.</p>

      <br>
      <p><b>PROPRIETOR GROW WITH STOCKS)</b><br>
      GOUTAM SHARMA, Research Analyst<br>
      SEBI (Research Analysts) Regulations 2014,<br>
      Registration No. INH000001212<br>
      BSE Enlistment no. : 5078</p>
      <br>
    </div>
  </section>
</template>

<script>
export default {
  name: "ConflictOfInterest",
  mounted() {
    document.title = "Conflict of Interest Guidelines | Grow With Stocks";
  }
};
</script>

<style lang="scss" scoped>
.grey_bg {
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 40px;
}
.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 24px;
}
p {
  color: #2d2d2d;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/views/ConflictOfInterest.vue